import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "src/redux/hooks";

import Header from "src/components/app/layout/Header";

import { getChatUrl } from "src/helpers/chatHelpers";
import { setLayoutProperties } from "src/redux/slices/configSlice";
import environment from "src/constants/environment";
import { IAppLayoutState } from "src/types/config.types";

const ChatScreen: React.FC = () => {
  const navigate = useNavigate();
  const params = useParams();
  const supportProgramKey = params["support-program-key"];
  const authState = useAppSelector((state) => state.auth);
  const dispatch = useAppDispatch();
  const [screenType, setScreenType] = useState<"chat-list" | "chat-window">(
    "chat-list"
  );

  useEffect(() => {
    const patientData = authState.patient?.data;
    if (!patientData) {
      console.error("Patient data not available");
      navigate(`/app/${supportProgramKey}/home-screen`);
      return;
    }

    const chatUrl = getChatUrl(patientData);
    if (!chatUrl) {
      console.error("Failed to build chat URL");
      navigate(`/app/${supportProgramKey}/home-screen`);
      return;
    }

    // Set the iframe source
    const iframe = document.getElementById("chat-iframe") as HTMLIFrameElement;
    if (iframe) {
      iframe.src = chatUrl;
    }

    window.addEventListener("message", function (event) {
      // Always verify the origin of the message sender for security
      if (event.origin !== environment.CHAT_URL) {
        return; // Message not from a trusted source
      }

      // event.data contains the message sent
      console.info("Message received:", event.data);
      const { payload, type } = event?.data;
      if (payload) {
        // setBackButton(payload?.path === "/chat");
        const screenType =
          payload?.path === "/chat" ? "chat-window" : "chat-list";
        setScreenType(screenType);

        const layoutProperties: IAppLayoutState = {
          showBottomBar: screenType === "chat-list",
        };
        dispatch(setLayoutProperties(layoutProperties));
      }
      if (type === "CDM_COACH_BOOK_APPOINTMENT") {
        navigate(`/app/${supportProgramKey}/book-consultation`, {
          state: {
            screenName: "program-screen",
          },
        });
      }

      // You can also access other properties like event.source (the window that sent the message)
      // and event.origin (the origin of the sender)
    });
  }, [authState.patient, supportProgramKey, navigate]);

  const handleBack = () => {
    // navigate(`/app/${supportProgramKey}/home-screen`);
    navigate(-1);
  };

  return (
    <div className="w-full flex flex-col h-full bg-white">
      {/* Header */}
      <Header
        title="Chats"
        titlePosition="center"
        showBackButton={screenType === "chat-window"}
        onBackClick={() => navigate(-1)}
      />

      {/* Chat Iframe */}
      <div className="flex-1 w-full relative">
        <iframe
          id="chat-iframe"
          className="w-full h-full border-0"
          title="Chat Support"
          allow="microphone; camera; fullscreen"
          sandbox="allow-same-origin allow-scripts allow-forms allow-popups allow-popups-to-escape-sandbox"
        />
      </div>
    </div>
  );
};

export default ChatScreen;
